module.exports = __webpack_public_path__ + "img/selbsterfahrung_1920.a392c63f.webp";